[
  {
    "code": "BA-BIH",
    "name": "Federacija Bosna i Hercegovina"
  },
  {
    "code": "BA-SRP",
    "name": "Republika Srpska"
  }
]